import { render, staticRenderFns } from "./SearchInputGames.vue?vue&type=template&id=12c4b007"
import script from "./SearchInputGames.vue?vue&type=script&lang=js"
export * from "./SearchInputGames.vue?vue&type=script&lang=js"
import style0 from "./SearchInputGames.vue?vue&type=style&index=0&id=12c4b007&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports